//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ViewportMixin from '@/mixins/viewport.mixin';

export default {
  mixins: [ViewportMixin],
  props: {
    end: {
      type: String,
      default: '',
    },
    currentTopicStart: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      days: '00',
      hours: '00',
      minutes: '00',
      seconds: '00',

      timer: null,
      currentTime: null,
      isEventEnded: false,

      endTime: null,
    };
  },
  computed: {
    showSeconds() {
      return (this.isMobile && this.days === '00') || !this.isMobile;
    },
    leftTime() {
      return this.endTime - this.currentTime;
    },
    timerEnded() {
      return this.leftTime < 0;
    },
    specialActive() {
      return false;
      // // Специальное предложение включается после окончания таймера
      // if (!this.timerEnded) return false;

      // // Время для активности специального предложения
      // // рассчитывается относительно последнего топика.
      // // Время начала последнего топика приходит в public/getSale
      // const lastTopicDateUtc = this.lastTopicDateUtc;
      // if (!lastTopicDateUtc) return false;

      // // Если ивент ещё не закончился (по-умолчанию - не прошло 30 часов
      // // с начала последнего топика), то кнопка активна и выводится
      // // текст специального предложения
      // const isEventEnded = this.$store.getters['eventsList/GET_IS_EVENT_ENDED']({
      //   vm: this,
      //   lastTopicDateUtc,
      // });

      // if (isEventEnded) this.$emit('eventEnded');

      // return !isEventEnded;
    },
  },
  mounted() {
    if (process.browser) {
      this.createTimer();
    }

    this.tickTimer();
  },
  methods: {
    calculateEndTime() {
      this.endTime = this.endTime.add(1, 'hour');
      if (this.leftTime < 0) {
        this.calculateEndTime();
      }
    },
    createTimer() {
      // таймер заряжен на два один час после начала вебинара
      this.endTime = this.$dayjs.utc(this.currentTopicStart).add(1, 'hour');

      this.timer = setInterval(this.tickTimer, 1000);
    },
    destroyTimer() {
      this.timer = clearInterval(this.timer);
    },
    calculateNumbers() {
      const duration = this.$dayjs.duration(
        this.leftTime - 1000,
        'milliseconds',
      );

      this.days = this.formatNumbers(duration.days());
      this.hours = this.formatNumbers(duration.hours());
      this.minutes = this.formatNumbers(duration.minutes());
      this.seconds = this.formatNumbers(duration.seconds());
    },
    formatNumbers(number) {
      if (number < 0) return '00';
      if (number < 10) return `0${number}`;
      return number;
    },
    tickTimer() {
      this.currentTime = this.$dayjs.utc();
      this.calculateNumbers();
      if (this.leftTime < 0) {
        const durationTillWebinarEnd =
          this.$dayjs.utc(this.end) - this.currentTime;

        if (durationTillWebinarEnd < 0) {
          this.destroyTimer();
          this.$emit('eventEnded');
          this.isEventEnded = true;
        } else {
          this.calculateEndTime();
        }
      }
    },
  },
};
